import { expireToken } from '.';

//TODO: ideally, we should just use the tokenExpired
export const TOKEN_EXPIRED = expireToken.type;
